import { useFormik } from 'formik';
import React from 'react';
import VoxelAlertDialog from '../../../components/voxel/Dialogs/VoxelAlertDialog';
import VoxelDialogActionCancel from '../../../components/voxel/Dialogs/VoxelDialogActionCancel';
import VoxelDialogActionSubmit from '../../../components/voxel/Dialogs/VoxelDialogActionSubmit';
import VoxelDialogActions from '../../../components/voxel/Dialogs/VoxelDialogActions';
import VoxelDialogContent from '../../../components/voxel/Dialogs/VoxelDialogContent';
import VoxelText from '../../../components/voxel/Text/VoxelText';
import { ProjectGq } from '../../../graphql/projects/models/ProjectGq';
import { projectsApiService } from '../../../graphql/projects/projectsApiService';

export interface UpdateTop10TrafficDomainsProps {
  project: ProjectGq;
  onSuccess: (project: ProjectGq) => Promise<any>;
  close: () => void;
}

const UpdateTop10TrafficDomains: React.FC<UpdateTop10TrafficDomainsProps> = ({
  project,
  onSuccess,
  close,
}) => {
  const updateTop10TrafficDomainsMutation = projectsApiService.mutations.projects.useRecalculateProjectCompetitors();
  const formikProps = useFormik<{}>({
    initialValues: {},
    onSubmit: (values, actions) =>
      updateTop10TrafficDomainsMutation({
        id: project.id,
      }).then((result) => onSuccess(result)),
  });

  return (
    <VoxelAlertDialog
      open={true}
      onClose={close}
      closeDisabled={formikProps.isSubmitting}
      title={'Update top 10 traffic domains'}
      maxWClass="max-w-2xl"
      severity='info'
    >
      <VoxelDialogContent classMinWidth="mt-4 min-w-fit">
        <VoxelText>
          If you've archived a lot of keywords since retrieving rank data, this may skew who the top 10 traffic domains are.
          <br></br>
          <br></br>
          Please note: This may take a while.
        </VoxelText>
      </VoxelDialogContent>
      <VoxelDialogActions>
        <VoxelDialogActionCancel onClick={close} disabled={formikProps.isSubmitting} />
        <VoxelDialogActionSubmit
          title={'Proceed'}
          onClick={formikProps.submitForm}
          disabled={formikProps.isSubmitting || !formikProps.isValid}
        />
      </VoxelDialogActions>
    </VoxelAlertDialog>
  );
};

export default UpdateTop10TrafficDomains;
